export default class LayoutManager extends HTMLElement {
  private onResizeBound = this.onResize.bind(this);

  connectedCallback(): void {
    this.addEventListeners();
  }

  addEventListeners(): void {
    window.addEventListener('resize', this.onResizeBound);
    this.onResize();
  }

  removeEventListeners(): void {
    window.removeEventListener('resize', this.onResizeBound);
  }

  onResize(): void {
    document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--window-width', `${window.innerWidth}px`);
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('layout-manager', LayoutManager);
